module.exports = __webpack_public_path__ + "img/type2.ffe3c744.png";